import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "./errorMessages";
import statuscode_es from "../translations/ES/statuscode.json";
import statuscode_en from "../translations/EN/statuscode.json";
import axios from "axios";

const searchFinderApi = axios.create({
  baseURL: 'https://test.ethicsglobal.com',
  //baseURL: "http://localhost:8000",
  timeout: 600000, // 10 minutos
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Interceptor para manejar errores
searchFinderApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ECONNABORTED") {
      console.error(
        "La solicitud de exportación de Excel ha excedido el tiempo de espera"
      );
      // Aquí puedes manejar el error, por ejemplo, mostrando un mensaje al usuario
    } else if (error.response) {
      console.error(
        "Error en la respuesta del servidor:",
        error.response.status
      );
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor");
    } else {
      console.error("Error al configurar la solicitud:", error.message);
    }
    return Promise.reject(error);
  }
);

export const searchFinderApiCall = async (
  method,
  url,
  data = null,
  config = {}
) => {
  try {
    const response = await searchFinderApi[method](url, data, config);
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

const lang = localStorage.getItem("lang");
const language = lang === "es" ? statuscode_es : statuscode_en;

//function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

export const createReport = async (report = {}, captchaToken) => {
  const tenant = getTenant();

  try {
    // Añadimos token y siteKey al objeto report
    const reportWithCaptcha = {
      ...report,
      entryway: "outdoor",
      event: {
        siteKey: "6LdCZ6wqAAAAADNDLaiULssUYnuqIx0MePGwJ_2N",
        token: captchaToken,
      },
    };

    const resp = await apiCall.post(
      `${tenant}/api/report/create/`,
      reportWithCaptcha
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const updateReport = async (id, answers) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/report/update/${id}/`,
      answers,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "reports"));
    throw error;
  }
};

export const getStatusReport = async (tracking_code) => {
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(`${tenant}/api/report/status/get/`, {
      tracking_code,
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Get Report List
export const getReports = async (params = {}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  const queryParams = {
    ordering: "-created_at",
    ...params,
  };

  try {
    const resp = await apiCall.get(`${tenant}/api/report/list/`, {
      params: queryParams,
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

// Get report search filters
export const getReportFilters = async () => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  try {
    const resp = await apiCall.get(`${tenant}/api/users/config/filters/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

// Save report search filters
export const saveReportFilters = async (payload) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  try {
    const resp = await apiCall.patch(
      `${tenant}/api/users/config/filters/`,
      payload,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

// Delete report search filter
export const deleteReportFilter = async (id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  try {
    const resp = await apiCall.delete(`${tenant}/api/users/config/filters/`, {
      params: { filter_id: id },
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "reports"));
    console.error(error.message);
    throw error;
  }
};

export const getReportDetail = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/report/detail/${id}`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });

    return resp.data;
  } catch (error) {
    console.error(error.message);
    return null;
  }
};

export const DeleteReport = async ({ reportid }) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(`${tenant}/api/report/trash/`, {
      data: {
        report_id: Number(reportid),
      },
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "reports"));
    console.error(error.message);
    throw error;
  }
};

export const getDetailReport = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/form-to-report/${id}/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    throw error;
  }
};

// Modify report comment
export const updateReportText = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/report/history/update/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

// Status
export const statusReport = async () => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/report/utilities/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const changeConfigurationSubStatus = async (updatedDataStructure) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/substatus/config/update/`,
      { updatedDataStructure },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const updateStatusReport = async ({
  report_id,
  status,
  comment,
  message,
  checkboxes,
}) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/report/status/update/`,
      { report_id, status, comment, message, checkboxes },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    throw error;
  }
};

export const updateStatusCloseDetails = async (report_id, details = {}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/report/status_close/update/`,
      { report_id, details },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Resolution update
export const updateResolutions = async (report_id, resolution) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/report/resolution/`,
      { report_id, resolution },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Get measures
export const getMeasures = async (report_identifier, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/resolution/measures/retrieve/?report_identifier=${report_identifier}&id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Create measures
export const createMeasure = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/resolution/measures/create/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Update measures
export const updateMeasure = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/report/resolution/measures/update/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Delete measure
export const deleteMeasures = async (report_identifier, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(
      `${tenant}/api/report/resolution/measures/delete/?report_identifier=${report_identifier}&id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Get sanctions
export const getSanctions = async (report_identifier, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/resolution/sanctions/retrieve/?report_identifier=${report_identifier}&id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Create sanctions
export const createSanctions = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/resolution/sanctions/create/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};
// Update sanctions
export const updateSanctions = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/report/resolution/sanctions/update/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};
// Delete sanctions
export const deleteSanctions = async (report_identifier, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(
      `${tenant}/api/report/resolution/sanctions/delete/?report_identifier=${report_identifier}&id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Get compensations
export const getCompensations = async (report_identifier, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/resolution/benefits/retrieve/?report_identifier=${report_identifier}&id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Create compensations
export const createCompensations = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/resolution/benefits/create/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};
// Delete compensation
export const deleteCompensations = async (report_identifier, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(
      `${tenant}/api/report/resolution/benefits/delete?report_identifier=${report_identifier}&id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
// Update compensatons
export const updateCompensations = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/report/resolution/benefits/update/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};

export const changeSeverity = async ({ report_id, path, comment = "" }) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/severity/`,
      { report_id, path, comment },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const changeReportSecure = async ({
  report_id,
  status_type,
  comment,
  comment_path,
  value,
}) => {
  const data = {
    status_type,
    comment_path,
    message: comment ?? "",
    value,
    report_id,
  };

  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/report/secure/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};

export const updateRangeDates = async ({
  report_identifier,
  comment,
  end_day,
}) => {
  const data = {
    report_identifier,
    comment: comment ?? "",
    end_day,
  };

  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/reports/custom_dates/`,
      { ...data },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    console.error(error);
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    throw error;
  }
};

export const getRelated = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/reports/related/`, {
      params: data,
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};

export const createRelated = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/reports/related/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    if (error.response.data.error === "The report already exists in the list") {
      showErrorMessage(`${language.this_report_is_already_linked}`);
    } else {
      showErrorMessage(
        getErrorMessage(error, "reports")
      );
    }
    console.error(error);
    throw error;
  }
};

export const changeRelated = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  try {
    const resp = await apiCall.put(`${tenant}/api/reports/related/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};

export const deleteRelated = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(
      `${tenant}/api/reports/related/?report_identifier=${data.report_identifier}&report_to_relate_identifier=${data.report_to_relate_identifier}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};

export const changeCompromisedAnonymity = async (props) => {
  const data = {
    report_identifier: props.report_identifier,
    value_to_assign: props.value_to_assign,
    comment: props.comment ?? "",
  };

  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/reports/compromised_anonymity/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};

export const changeHostileEnvironment = async (props) => {
  const data = {
    comment: props.comment ?? "",
    report_identifier: props.report_identifier,
    value_to_assign: props.value_to_assign,
  };

  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/reports/is_hostile_place/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error);
    throw error;
  }
};

// utilities for get users that arent assigned to a specific report
export const listAssignedUsers = async (id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/assigned-users-from-report/?report_id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const listAssignedAllUsers = async (id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/assigned-users-from-report/?report_id=${id}&show=all`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

// utilities for get users that arent assigned to a specific report
export const listUsersWithoutSpecificReport = async (id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/list-users-without-this-report/?report_id=${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const searchNavbarAPI = async (data) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;

  try {
    const resp = await searchFinderApiCall(
      "get",
      `/${tenant}/api/report/search_list/`,
      {
        params: data,
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );

    return resp;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const getBitacora = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  try {
    const resp = await apiCall.get(`${tenant}/api/report/log/`, {
      params: data, // Envía los datos como parámetros de la URL
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });

    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const createTags = async ({ id, key }) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/reports/tags/by_color/`,
      { tag: key },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
        params: {
          report_id: id,
        },
      }
    );

    return resp;
  } catch (error) {
    console.error(error);
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};

export const deleteTags = async ({ id, key }) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  try {
    const resp = await apiCall.delete(`${tenant}/api/reports/tags/by_color/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
      params: { report_id: id, tag: key },
    });

    return resp;
  } catch (error) {
    console.error(error);
    showErrorMessage(
      getErrorMessage(error, "reports")
    );
    console.error(error.message);
    throw error;
  }
};
